import { render, staticRenderFns } from "./ServiceSupportComplete.vue?vue&type=template&id=f6c50ba8&"
import script from "./ServiceSupportComplete.vue?vue&type=script&lang=js&"
export * from "./ServiceSupportComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports